import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { first } from 'rxjs';

export const bookValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const title = control.get('title');
  const summary = control.get('summary');
  const author = control.get('author')

  var isValid = false

  if (title != null && title.value != "" && summary != null && summary.value != "" && author != null && author.value != "")  {
    isValid = true
  } else {
    isValid = false
  }

  return isValid ? null : { valid: true };
};